var $4f595d05d8424d77$exports = {};
$4f595d05d8424d77$exports = {
    "(optional)": `(\u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    "(required)": `(\u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`
};


export {$4f595d05d8424d77$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
